import { CityBreakTickets } from 'components/common/CityBreak/components/CityBreakBox/components/CityBreakTickets'
import Loader from 'components/shared/Loader'
import useCityBreak from 'components/common/CityBreak/utils/useCityBreak'
import { useIntl } from 'react-intl'
import Box from 'components/shared/Box'

export const CityBreakTicketsOffer = () => {
    const { formatMessage } = useIntl()
    const {
        datesRange,
        daysNumber,
        ticketsOffer,
        isCityBreakDealingWithParkTickets,
    } = useCityBreak()

    return ticketsOffer.length === 0 ? (
        <Loader />
    ) : (
        <Box mt={24} isFullWidth>
            <CityBreakTickets
                title={
                    isCityBreakDealingWithParkTickets
                        ? formatMessage({
                              id: 'promo.city_break.park_tickets_to_add',
                              defaultMessage: '_',
                          })
                        : undefined
                }
                datesRange={datesRange}
                tickets={ticketsOffer}
                daysNumber={daysNumber}
                hasPromoTickets
            />
        </Box>
    )
}
